import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export const adminApi = (user, pass) =>
  axios.create({
    baseURL: API_BASE,
    auth: { username: user, password: pass },
  });

export const formatPrice = (value, currency = "EUR") => {
  try {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value} ${currency}`;
  }
};

export const youtubeEmbedUrl = (videoUri) => {
  if (!videoUri) return null;
  // videoUri usually is https://www.youtube.com/watch?v=XXXX
  try {
    const url = new URL(videoUri);
    const v = url.searchParams.get("v");
    if (v) return `https://www.youtube.com/embed/${v}`;
    // youtu.be/XXXX
    if (url.hostname.includes("youtu.be")) {
      const id = url.pathname.replace("/", "");
      return `https://www.youtube.com/embed/${id}`;
    }
  } catch {
    return null;
  }
  return null;
};
